import { listingReducer } from "../reducers/utils/listingReducer";
import {getAirprtsList} from "../../services/Airports";

const { reducer, actions, types } = listingReducer({
  name: `airports`,
  getApi: getAirprtsList,
});
const airports = reducer;
export { airports, actions, types };